import React from "react";
import { useTranslation } from "react-i18next";
import { ContextHelp } from "../../ui";
import { NativeSelect } from "../../ui/UIElements/Select";
import {
  BRANCH_SELECTION_MODE_OPTIONS,
  normalizeBranchSelectionMode,
} from "../../../lib/aiAgentBranchSelection";

/**
 * Select for the agent's branch selection mode (`settings.branch_selection_mode`).
 * Used by both the create and the edit agent modals.
 */
const BranchSelectionModeField = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation("aiAgents");
  const selectedValue = normalizeBranchSelectionMode(value);

  return (
    <div>
      {/* ContextHelp sits outside the label so it is not labelled by it too */}
      <div className="mb-2 flex items-center gap-1">
        <label
          htmlFor="branch-selection-mode"
          className="text-foreground text-sm font-medium"
        >
          {t("branchSelection.label")}
        </label>
        <ContextHelp
          className="h-3.5 w-3.5"
          ariaLabel={t("branchSelection.help.ariaLabel")}
          whatIs={t("branchSelection.help.whatIs")}
          note={t("branchSelection.help.note")}
        />
      </div>
      <NativeSelect
        id="branch-selection-mode"
        value={selectedValue}
        onChange={(e) => onChange(normalizeBranchSelectionMode(e.target.value))}
        disabled={disabled}
        aria-describedby="branch-selection-mode-description"
        className="w-full"
      >
        {BRANCH_SELECTION_MODE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {t(`branchSelection.options.${option.value}.label`)}
          </option>
        ))}
      </NativeSelect>
      <p
        id="branch-selection-mode-description"
        className="text-muted-foreground mt-1 text-xs"
      >
        {t(`branchSelection.options.${selectedValue}.description`)}
      </p>
    </div>
  );
};

export default BranchSelectionModeField;
